import { render } from "./ai-dictionary-grid.vue?vue&type=template&id=1c3ea22a"
import script from "./ai-dictionary-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-dictionary-grid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/dictionary-components/ai-dictionary-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c3ea22a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c3ea22a', __exports__)) {
    api.reload('1c3ea22a', __exports__)
  }
  
  module.hot.accept("./ai-dictionary-grid.vue?vue&type=template&id=1c3ea22a", () => {
    api.rerender('1c3ea22a', render)
  })

}


export default __exports__